import { icons } from "lucide-react";

type IconProps = {
  name: keyof typeof icons | null;
  color?: string;
  size?: number;
  style?: React.CSSProperties;
};

const Icon = (props: IconProps) => {
  const { name, color = "currentColor", size = 18, style } = props;
  if (!name) return null;
  const LucideIcon = icons[name];

  return <LucideIcon color={color} size={size} style={style} />;
};

export default Icon;
